module.exports = __webpack_public_path__ + "img/6-Intersection 2.8ce13e75.png";